var exports = {
  "U": "xcc377c0b--811a0e--arrow",
};

module.exports = exports;
